import { render, staticRenderFns } from "./LocationBadge.vue?vue&type=template&id=0854e454"
import script from "./LocationBadge.vue?vue&type=script&lang=js"
export * from "./LocationBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports